import { QueryClient } from '@tanstack/react-query';

/**
 * TanStack Query client with sensible defaults for the NIRC platform.
 * staleTime: 30 s — matches §14.4 pattern.
 * retry: 1 — don't hammer a broken server; surface errors quickly.
 * gcTime (cacheTime): 5 min — keeps data alive across short navigations.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: 0,
    },
  },
});
